import { IconMediaPlayArrow16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { AutoZoomContainer } from '../AutoZoomContainer';
import { BlurContainer } from '../BlurContainer';
import * as styles from './Video.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Video = function Video(props) {
  var _props$backgroundSize = props.backgroundSize,
      backgroundSize = _props$backgroundSize === void 0 ? 'cover' : _props$backgroundSize,
      blurBackground = props.blurBackground,
      _props$showPlayButton = props.showPlayButton,
      showPlayButton = _props$showPlayButton === void 0 ? true : _props$showPlayButton;
  var previewUrl = getVideoPreview(props);

  var playButton = props.playButton || /*#__PURE__*/_jsx("div", {
    className: styles['play-button'],
    children: /*#__PURE__*/_jsx(IconMediaPlayArrow16, {
      color: "icon-main-default"
    })
  });

  var ref = React.useRef(null);
  return /*#__PURE__*/_jsx(BlurContainer, {
    enabled: blurBackground,
    background: previewUrl,
    children: /*#__PURE__*/_jsx(AutoZoomContainer, {
      childRef: ref,
      children: /*#__PURE__*/_jsx("div", {
        className: styles['container'],
        style: {
          backgroundImage: "url(".concat(previewUrl, ")"),
          backgroundSize: backgroundSize
        },
        ref: ref,
        children: showPlayButton && playButton
      })
    })
  });
};
var YOUTUBE_LINK_REGEX = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;

function getVideoPreview(_ref) {
  var previewUrl = _ref.previewUrl,
      src = _ref.src;

  if (previewUrl) {
    return previewUrl;
  }

  var srcMatch = YOUTUBE_LINK_REGEX.exec(src);

  if (!srcMatch) {
    return null;
  }

  return "https://img.youtube.com/vi/".concat(srcMatch[1], "/hqdefault.jpg");
}